import React from "react";
import { useNavigate } from "react-router-dom";
import "./ModalSemPermissao.css";

export default function ModalSemPermissao() {
  const navigate = useNavigate();

  const voltarParaHome = () => {
    navigate("/"); // SPA: navega para a home sem recarregar a página
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>⛔ Acesso negado</h2>
        <p>Você não tem permissão para acessar esta área.</p>
        <button className="btn-fechar" onClick={voltarParaHome}>
          ← Voltar ao início
        </button>
      </div>
    </div>
  );
}
